import { Avatar, Banner } from "react-native-paper";

import type { FontSchemaType } from "../types";
import { useAppTheme } from "../useAppTheme";
import RenderMarkdown from "./MarkdownRenderer";

type Props = {
	visible: boolean;
	font?: FontSchemaType;
	title: string;
	handleClickAction: (type: "dismiss" | "switch-exam") => void;
	primaryCta: string;
};

const AppContextBanner = ({
	visible,
	font,
	title,
	handleClickAction,
	primaryCta,
}: Props) => {
	const theme = useAppTheme();
	return (
		<Banner
			visible={visible}
			elevation={0}
			style={{
				backgroundColor: theme.colors.surfaceVariant,
			}}
			actions={[
				{
					label: "Dismiss",
					onPress: () => handleClickAction("dismiss"),
				},
				{
					label: primaryCta,
					onPress: () => handleClickAction("switch-exam"),
				},
			]}
			contentStyle={{
				maxWidth: "100%",
			}}
			icon={({ size }) => (
				<Avatar.Icon
					icon={"swap-horizontal-variant"}
					size={size}
					style={{
						backgroundColor: theme.colors.onSurfaceVariant,
					}}
				/>
			)}
		>
			<RenderMarkdown
				text={title}
				appFont={font}
				customStyles={{
					text: {
						color: theme.colors.onSurface,
					},
				}}
			/>
		</Banner>
	);
};

export default AppContextBanner;
